// extracted by mini-css-extract-plugin
export default {"image":"HotelImages_image__dE2db"};